import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  linkActiveClass:'active',
  // mode: 'history',
  routes: [
    {
      path: '/index',
      component: () => import('@/views/index')
    },
    {
      path: '/currency',//贷币
      component: () => import('@/views/currency')
    },
    {
      path: '/repayment',//还款详情
      component: () => import('@/views/repayment')
    },
    {
      path: '/repayment2',//还款详情
      component: () => import('@/views/repayment2')
    },
    {
      path: '/currencyRecord',
      component: () => import('@/views/currencyRecord')
    },
    {
      path: '/subscription',//新币申购
      component: () => import('@/views/subscription')
    },
    {
      path: '/subscribe',//新币申购
      component: () => import('@/views/subscribe')
    },
    {
      path: '/login',
      component: () => import('@/views/login')
    },
    {
      path: '/register',
      component: () => import('@/views/register')
    },
    {
      path: '/text',
      component: () => import('@/views/text')
    },
    {
      path: '/bannerDetail',
      component: () => import('@/views/bannerDetail')
    },
    {
      path: '/agrt',
      component: () => import('@/views/agrt')
    },
    {
      path: '/agreement',
      component: () => import('@/views/agreement')
    },
    {
      path: '/about',
      component: () => import('@/views/about')
    },
    {
      path: '/help',
      title: '帮助中心列表',
      component: () => import('@/views/help')
    },
    {
      path: '/helpDetail',
      title: 'helpDetail',
      component: () => import('@/views/helpDetail')
    },
    {
      path: '/forgetpwd',
      title: '忘记密码',
      component: () => import('@/views/forgetpwd')
    },
    {
      path: '/bindmpwd',
      title: '设置交易密码',
      component: () => import('@/views/bindmpwd')
    },
    {
      path: '/bindphone',
      title: '绑定手机号码',
      component: () => import('@/views/bindphone')
    },
    {
      path: '/deal',
      title: '币币交易',
      component: () => import('@/views/deal/index')
    },
    {
      path: '/market',
      title: '行情',
      component: () => import('@/views/market')
    },
    {
      path: '/deal_c',
      title: '合约交易',
      component: () => import('@/views/deal/deal_c')
    },
    {
      path: '/deal_jg',
      title: '交割合约',
      component: () => import('@/views/deal/deal_jg')
    },
    {
      path: '/lt',
      title: '合约持仓',
      component: () => import('@/views/deal/leverTransactions')
    },
    {
      path: '/jgcc',
      title: '交割持仓',
      component: () => import('@/views/deal/jgcc')
    },
    {
      path: '/all',
      title: '全部',
      component: () => import('@/views/deal/allDeal')
    },
    {
      path: '/dealList',
      title: '交易记录',
      component: () => import('@/views/deal/leverList')
    },
    {
      path: '/notice',
      title: '公告中心',
      component: () => import('@/views/notice')
    },
    {
      path: '/noticeFooter',
      title: '公告中心',
      component: () => import('@/views/noticeFooter')
    },
    {
      path: '/profit_index',
      title: '搬砖获利',
      component: () => import('@/views/profit/profit_index')
    },
    {
      path: '/profit_wdtg',
      title: '我的托管',
      component: () => import('@/views/profit/profit_wdtg')
    },
    {
      path: '/profit_buy',
      title: '购买',
      name: 'profit_buy',
      component: () => import('@/views/profit/profit_buy')
    },
    {
      path: '/revenueDetails',
      title: '收益详情',
      component: () => import('@/views/profit/revenueDetails')
    },
    {
      path: '/downLoad',
      title: '下载',
      component: () => import('@/views/downLoad')
    },
    {
      path: '/recharge',
      title: '充币',
      component: () => import('@/views/recharge')
    },
    {
      path: '/money',
      title: '提币',
      component: () => import('@/views/money')
    },
    {
      path: '/team',//团队介绍
      title: 'team',
      component: () => import('@/views/team')
    },
    {
      path: '/asset',
      redirect: '/table1',
      component: () => import('@/views/asset/index'),
      children: [
        {
          path: '/table1',
          component: () => import('@/views/asset/asset-table1')
        },
        {
          path: '/table2',
          component: () => import('@/views/asset/asset-table2')
        },
        {
          path: '/record',
          title: '记录',
          component: () => import('@/views/asset/asset-record')
        },
        {
          path: '/transfer',
          title: '划转',
          component: () => import('@/views/asset/asset-transfer')
        },
        {
          path: '/address',
          title: '提币地址管理',
          component: () => import('@/views/asset/asset-address')
        }
      ]
    },
    {
      path: '/authentication',
      title: '身份认证',
      component: () => import('@/views/account/authentication')
    },
    {
      path: '/addcard',
      title: '添加银行卡',
      component: () => import('@/views/account/addcard')
    },
    {
      path: '/addcardRecord',
      title: '提现记录',
      component: () => import('@/views/account/addcard-record')
    },
    // {
    //   path: '/account',
    //   title: '账户',
    //   component: () => import('@/views/account/index')
    //  },
      {
        path: '/rechargeRecord',
        title: '充币记录',
        component: () => import('@/views/account/recharge-record')
      },
      {
        path: '/moneyRecord',
        title: '提币记录',
        component: () => import('@/views/account/money-record')
      },
      {
        path: '/accountRecord',
        title: '账户记录',
        component: () => import('@/views/account/account-record')
      },
      {
        path: '/exchange',
        title: '兑换',
        component: () => import('@/views/account/exchange')
      },
      {
        path: '/service',
        title: '联系我们',
        component: () => import('@/views/account/service')
      },
      {
        path: '/welfare',
        title: '福利专区',
        component: () => import('@/views/account/welfare')
      },
      {
        path: '/welfareDetail',
        title: '福利专区详情',
        component: () => import('@/views/account/welfare-detail')
      },
      {
        path: '/settingNew',
        title: '新闻快讯',
        component: () => import('@/views/account/setting-new')
      },
      {
        path: '/setting-newdetail',
        title: '新闻',
        component: () => import('@/views/account/setting-newdetail')
      },
      {
        path: '/settingHelp',
        title: '帮助中心',
        component: () => import('@/views/account/setting-help')
      },
      {
        path: '/settingAbout',
        title: '关于我们',
        component: () => import('@/views/account/setting-about')
      },
      {
        path: '/invite',
        title: '邀请好友',
        component: () => import('@/views/account/invite')
      },
      {
        path: '/credit',//信用分
        title: 'credit',
        component: () => import('@/views/person/person-credit')
      },
      {
        path: '/asset',
        title: '资产',
        component: () => import('@/views/account/asset')
      },
      {
        path: '/editPassword',
        title: '修改密码',
        component: () => import('@/views/account/editpassword')
      },
    {
      path: '/editPasswordTrade',
      title: '交易密码',
      component: () => import('@/views/account/editpassword-trade')
    },
    {
      path: '/benefits',
      component: () => import('@/views/benefits')
    },
    {
      path: '/benefitsDetail',
      component: () => import('@/views/benefitsDetail')
    },
    {
      path: '*',
      component: () => import('@/views/404')
    },
    {
      path: '/',
      component: () => import('@/views/index')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js